import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=4c426958&scoped=true"
import script from "./DataTable.vue?vue&type=script&lang=ts"
export * from "./DataTable.vue?vue&type=script&lang=ts"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=4c426958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c426958",
  null
  
)

export default component.exports